<template>
    <div>
        <div class="nav-tabs-container pt-1" v-if="!hideTabs">
            <div class="nav-tabs-scroll-helper">
                <ul class="nav nav-tabs">

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'all'}" href id="tabLinkDeductions1" role="tab" aria-controls="tabContentDeductions1" :aria-selected="mode == 'all'" @click.prevent="mode = 'all'; $bus.$emit('resize')">
                            All Deductions ({{ allDeductionsCount }})
                        </a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'selected'}" href id="tabLinkDeductions2" role="tab" aria-controls="tabContentDeductions1" :aria-selected="mode == 'selected'" @click.prevent="mode = 'selected'; $bus.$emit('resize')">
                            Selected ({{ selectedDeductionsCount }})
                        </a>
                    </li>

                </ul>
            </div>
        </div>

        <div class="flex-body flex-container tab-content deduction-selector">
            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'all'}" id="tabContentDeductions1" role="tabpanel" aria-labelledby="tabLinkDeductions1">
                <fast-table
                    v-if="mode == 'all'"
                    :sections="deductionSections"
                    :headers="deductionHeaders"
                    :data="deductionTableData"
                    @click="onDeductionClick"
                    @select="onDeductionSelect"
                    :has-row-select="true"
                    :show-search="!hideSearch"
                    :show-filter="false"
                    :show-more-actions="false"
                />

            </div>

            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'selected'}" id="tabContentDeductions2" role="tabpanel" aria-labelledby="tabLinkDeductions2">
                <fast-table
                    v-if="mode == 'selected'"
                    :sections="deductionSections"
                    :headers="deductionHeaders"
                    :data="selectedDeductionTableData"
                    @click="onDeductionClick"
                    @select="onDeductionSelect"
                    :has-row-select="true"
                    :show-search="!hideSearch"
                    :show-filter="false"
                    :show-more-actions="false"
                />

            </div>
        </div>
    </div>
    </template>

    <script>
    import FastTable from '@/components/FastTable'

    export default {
        props: ['modelValue', 'availableDeductions', 'hideSearch', 'hideTabs'],
        emits: ['update:modelValue'],
        components: {FastTable, },
        computed: {
            deductionTableData() {
                const result = []

                this.deductions.forEach(c => {
                    result.push({
                        id: c.id,
                        isSelected: this.formData.deductions.includes(c.id),
                        object: c,
                        cells: [
                            c.name,
                        ],
                    })
                })

                return [result]
            },
            selectedDeductionTableData() {
                let result = this.deductionTableData[0].filter(row => {
                    return this.formData.deductions.includes(row.object.id)
                })

                result = JSON.parse(JSON.stringify(result))
                result.forEach(row => {
                    row.isSelected = true
                })

                return [result]
            },
            allDeductionsCount() {
                return this.deductionTableData[0].length
            },
            selectedDeductionsCount() {
                return this.selectedDeductionTableData[0].length
            },
        },
        data() {
            return {
                mode: 'all',
                deductions: this.availableDeductions || [],
                formData: {
                    deductions: Array.from(this.modelValue),
                },
                deductionSections: [
                    {title: 'All', id: 'all'},
                ],
                deductionHeaders: [
                        {label: 'Deduction', classes: 'cell-deduction', defaultSort: true, isFilterable: false, isSearchable: true, },
                ],
            }
        },
        mounted() {
            this.$bus.$emit('resize')
            if (!this.availableDeductions) {
                this.getDeductions()
            }
        },
        methods: {
            getDeductions() {
                this.$store.dispatch('START_LOADING')
                this.$api.get('/admin/tax-engine/deduction-types').then(resp => {
                    this.deductions = resp
                    this.$store.dispatch('STOP_LOADING')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    if (errors.__status__ == 403) {
                        this.$bus.$emit('no-access')
                    }
                    else {
                        this.$bus.showError(errors.__all__)
                    }
                })
            },
            onDeductionSelect(rows) {
                const deductions = new Set()
                rows.forEach(row => {
                    deductions.add(row.object.id)
                })

                this.formData.deductions = Array.from(deductions)

                this.$emit('update:modelValue', this.formData.deductions)
            },
            onDeductionClick(deduction) {
                if (this.formData.deductions.includes(deduction.id)) {
                    this.formData.deductions = this.formData.deductions.filter(cId => cId != deduction.id)
                }
                else {
                    this.formData.deductions.push(deduction.id)
                }

                this.$emit('update:modelValue', this.formData.deductions)
            },
        },
    }

    </script>

    <style>
    .deduction-selector .table-wrapper {
        min-height: 300px;
    }
    </style>
